export default __webpack_public_path__ + "static/media/Rune Stone of the Emerald Lotus.4a6fc030.jpg";